/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import styles from './masthead.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { prefix, stablePrefix: c4dPrefix } = settings;

/**
 * Masthead.
 *
 * @element c4d-masthead-l1-name
 * @csspart l1-name-title - The title element. Usage: `c4d-masthead-l1-name::part(l1-name-title)`
 * @csspart l1-name-link - The link element. Usage: `c4d-masthead-l1-name::part(l1-name-link)`
 */
@customElement(`${c4dPrefix}-masthead-l1-name`)
class C4DMastheadL1Name extends StableSelectorMixin(LitElement) {
  /**
   * slot name for this component in the masthead l1
   */
  @property({ reflect: true })
  slot = 'name';

  @property({ reflect: true })
  url = '';

  @property({ reflect: true })
  title = '';

  render() {
    return html`
      <span part="l1-name-title" class="${prefix}--masthead__l1-name-title">
        <a part="l1-name-link" href="${this.url}">${this.title}</a>
      </span>
    `;
  }

  static get stableSelector() {
    return `${c4dPrefix}--masthead__l1-name`;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

export default C4DMastheadL1Name;
